import {createSelector} from 'reselect'
import * as app from '../../application.selectors';

export const documentation = createSelector(
  state => state.record.entities.documentation,
  state => state.record.deletedDocumentation,
  (docs, removed) => Object.keys(docs)
    .filter(id => !removed.includes(id))
    .map(id => docs[id])
);

export const period = createSelector(
  state => state.record.entities.periods[state.record.periodId],
  app.userFacility,
  (period, userFacility) => {
    if (!period) {
      return {};
    } else {
      const facilityStatus = (period.facilityStatuses) ? period.facilityStatuses.find(s => s.nursingFacilityId === userFacility.id && s.periodId === period.id) : null;

      return {...period, facilityStatus: facilityStatus ? facilityStatus.status : ''};
    }
  }
);

export const record = createSelector(
  state => state.record.entities.patients[state.record.recordId],
  record => record || {}
);




// WEBPACK FOOTER //
// ./src/modules/record/record.selectors.js